/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  useEffect,
  useMemo,
  useState
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  RouteComponentProps,
  withRouter
} from 'react-router-dom';

import { Box } from '@mui/material';
import styled from 'styled-components';

import {
  Dialog,
  Header,
  SplashLoader
} from '../../components';
import { withAPIService } from '../../networking';
import { languageSelection } from '../../shared/translationConfig/helper';
import { withStore } from '../../store';
import FaqCategoryTitle from '../FaqCategoryTitle';
import Template from '../Template';
import { FaqContext } from './FaqContext';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: var(--spacing-4xl);
  padding-left: var(--spacing-4xl);

  @media (max-width: 900px) {
    padding-right: 0px;
    padding-left: 0px;
  }
`;

interface FaqPageProps extends RouteComponentProps {
  store: any;
}

export function FaqPageCom({
  location,
  store,
}: FaqPageProps) {
  const { pathname } = location;
  const { customer } = store;

  const { t, i18n } = useTranslation();

  const [language, setLanguage] = useState('en');
  const [accstatus, setAccstatus] = useState<any>({});

  const faqs = t('Faq', { returnObjects: true });

  useEffect(() => {
    const sessionLang = languageSelection();

    i18n.changeLanguage(
      sessionLang || customer.languageCode || 'en'
    );
  }, [language, i18n]);

  const handleToggle = (index: number) => {
    if (
      Object.keys(accstatus).indexOf(
        index.toString()
      ) !== -1
    ) {
      setAccstatus((prev: any) => ({
        ...prev,
        [index]: !prev[index]
      }));
    } else {
      const finalStatus = { ...accstatus };
      finalStatus[index] = true;
      setAccstatus(finalStatus);
    }
  };

  const contextValue = useMemo(
    () => ({ language, setLanguage }),
    [language, setLanguage]
  );

  return (
    <Template>
      <Wrapper>
        <FaqContext.Provider
          value={contextValue}
        >
          <Dialog />

          <ContentWrapper>
          <Header
            pathname={pathname}
            title={t('FaqTitle')}
            isOnlyUtility={false}
          />
            {Array.isArray(faqs) ? (
              <Box
                sx={{
                  marginTop: 'var(--spacing-xl)',
                  width: '100%'
                }}
              >
                {faqs.map((faq: any, index: number) => (
                  <FaqCategoryTitle
                    onToggle={() =>
                      handleToggle(index)
                    }
                    active={accstatus[index]}
                    key={faq.id ?? faq.title ?? `faq-${index}`}
                    faq={faq}
                  />
                ))}
              </Box>
            ) : (
              <SplashLoader />
            )}
          </ContentWrapper>
        </FaqContext.Provider>
      </Wrapper>
    </Template>
  );
}

const connectRouter = withRouter(FaqPageCom);
const connectAPI = withAPIService(connectRouter);
const FaqPage = withStore(connectAPI);

export { FaqContext } from './FaqContext';
export default FaqPage;